module.exports = __webpack_public_path__ + "static/media/before-after-ash.8d7a4cdc.png";